import {httpLogout, httpUserMe} from '@/features/auth/services/auth.http.ts'
import i18next from 'i18next'
import {useAuthStore} from '@/features/auth/store/store.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {AuthUser} from '@/features/auth/types.ts'
import {toast} from '@/utilities/toast/toast'
import {
    IMPERSONATION_ORIGINAL_ACCESS_TOKEN,
    IMPERSONATION_ORIGINAL_REFRESH_TOKEN,
    IMPERSONATION_STARTED_AT
} from '@/features/auth/constants.ts'

export const userMe = async () => {
    try {
        const user = await parseAxiosPromise({
            axiosPromise: httpUserMe(),
            onZodError: captureException,
            responseShape: AuthUser
        })
        useAuthStore.setState(() => ({user}))
    } catch (e) {
        toast.error(i18next.t('errors:default'))
    }
}

export const logout = async () => {
    try {
        await httpLogout()
        // An explicit logout ends both sessions: dropping the set-aside tokens here stops the operator's
        // own session from being silently resurrected after logging out from an impersonated one.
        localStorage.removeItem(IMPERSONATION_ORIGINAL_ACCESS_TOKEN)
        localStorage.removeItem(IMPERSONATION_ORIGINAL_REFRESH_TOKEN)
        localStorage.removeItem(IMPERSONATION_STARTED_AT)
        useAuthStore.getState().reset()
    } catch (e) {
        toast.error(i18next.t('errors:default'))
    }
}
